import React, {useEffect, useState} from "react";
import Input from "../components/cmp/form/Input";
import {getAccessToken, setAccessToken} from "../api";
import Checkbox from "../components/cmp/form/Checkbox";
import {getItem, removeItem, setItem} from "../tools/storage";

function DevPage(){

    const [portalSubdomain, setPortalSubdomain] = useState(getItem('x-shop'));
    const [accessToken, setAToken] = useState(getAccessToken());
    const [devMode,  setDevMode] = useState(!!getItem('isdev'))

    useEffect(()=>{
        if(devMode) {
            setItem('isdev', '1')
        }else{
            removeItem('isdev')
        }
    },[devMode])

    if(document.location.hostname !== 'localhost'){
        window.location.href = `http://localhost:3001/dev?access_token=${getAccessToken()}&x-shop=${document.location.hostname}`
        return null;
    }
    const params = new URL(document.location.href).searchParams;
    if(params.has('access_token')){
        setAccessToken(params.get('access_token'))
        setItem('x-shop', params.get('x-shop'))
        window.location.href = "/"
        return null;
    }

    const onPortalSubdomain = (state)=>{
        if(state.includes('login-as')){
            const u = new URL(state)
            const value = u.pathname.split("/").pop();
            const host = u.hostname;
            setAToken(value);
            setAccessToken(value)
            setPortalSubdomain(host)
            setItem('x-shop', host)
        }else{
            setPortalSubdomain(state)
            setItem('x-shop',state)
        }
    }

    return <div className={"container"}>
        <div className="py-4">
            <div className={"card"}>
                <div className="card-body">
                    <div className="form-group">
                        <label>Portal subdomain</label>
                        <Input type="text" value={portalSubdomain} onChange={onPortalSubdomain}/>
                    </div>
                    <div className="form-group">
                        <label>Auth token</label>
                        <Input type="text" value={accessToken} onChange={(value)=>{
                            setAToken(value)
                            setAccessToken(value)

                        }} />
                    </div>
                    <div className="form-group">
                        <Checkbox label={"Development mode ?"} checked={devMode} onChange={(e)=>setDevMode(e.target.checked)} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default DevPage
